import { Tooltip } from '@mui/material'
import { withStyles } from '@mui/styles'

const StyledTooltip = withStyles({
    tooltip: {
        backgroundColor: '#404040'
    },
    arrow: {
        color: '#404040'
    }
  })(Tooltip);

  export default StyledTooltip